











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('DashboardGrantLevelQuery')
    
    export class DashboardGrantLevelQuery  {
        constructor( userId: number ) {
            
                this.userId = userId;
            
        }

        
            
            public userId: number;
        

        

        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: DashboardGrantLevelQuery ) {
                return new QueryExecutor<DashboardGrantLevelQuery, DashboardGrantLevelQueryResult>(DashboardGrantLevelQueryResult, query);
            }

            

            
        
    }

    

    
        /**
        * The result model for DashboardGrantLevelQuery.
        */
        export class DashboardGrantLevelQueryResult {
            
                
                 dashboardId: number;
            
                
                 name: string;
            
                
                 grantLevel: number;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace DashboardGrantLevelQuery.ExtraneousTypes {
        

        
    }

